import { MenuLabel, RoutePath } from "@app/constants";

export const getHeaderLabel = (pathname: string) => {
  switch (true) {
    case pathname.includes(RoutePath.STATISTICS):
      return MenuLabel.STATISTICS;
    case pathname.includes(RoutePath.BOOK_MANAGEMENT):
      return MenuLabel.BOOK_MANAGEMENT;
    case pathname.includes(RoutePath.BANNER_MANAGEMENT):
      return MenuLabel.BANNER_MANAGEMENT;
    case pathname.includes(RoutePath.USER_MANAGEMENT):
      return MenuLabel.USER_MANAGEMENT;
    case pathname.includes(RoutePath.CATEGORY_MANAGEMENT):
      return MenuLabel.CATEGORY_MANAGEMENT;
    case pathname.includes(RoutePath.BACKGROUND_MUSIC_MANAGEMENT):
      return MenuLabel.BACKGROUND_MUSIC_MANAGEMENT;
    case pathname.includes(RoutePath.TRANSACTION_MANAGEMENT):
      return MenuLabel.TRANSACTION_MANAGEMENT;
    case pathname.includes(RoutePath.BANK_MANAGEMENT):
      return MenuLabel.BANK_MANAGEMENT;
    case pathname.includes(RoutePath.VOUCHER_IMPORT):
      return MenuLabel.VOUCHER_IMPORT;
    case pathname.includes(RoutePath.ACCOUNT_INFO):
      return MenuLabel.ACCOUNT_INFO;
    case pathname.includes(RoutePath.CONTENT_MANAGEMENT):
      return MenuLabel.CONTENT_MANAGEMENT;
    case pathname.includes(RoutePath.SETTING_MANAGEMENT):
      return MenuLabel.SETTING_MANAGEMENT;
    case pathname.includes(RoutePath.NOTIFICATION_MANAGEMENT):
      return MenuLabel.NOTIFICATION_MANAGEMENT;
    case pathname.includes(RoutePath.CAMPAIGN_MANAGEMENT):
      return MenuLabel.CAMPAIGN_MANAGEMENT;
    case pathname.includes(RoutePath.ADVERTISE_MANAGEMENT):
      return MenuLabel.ADVERTISE_MANAGEMENT;
    case pathname.includes(RoutePath.VOUCHER_ACTIVE_MANAGEMENT):
      return MenuLabel.VOUCHER_ACTIVE_MANAGEMENT;
    case pathname.includes(RoutePath.ALERT_SYSTEM_MANAGEMENT):
      return MenuLabel.ALERT_SYSTEM_MANAGEMENT;
    case pathname.includes(RoutePath.MEDIA_MANAGEMENT):
      return MenuLabel.MEDIA_MANAGEMENT;
    case pathname.includes(RoutePath.BOOK_SEGMENT_MANAGEMENT):
      return MenuLabel.BOOK_SEGMENT_MANAGEMENT;
    case pathname.includes(RoutePath.SQL_EDITOR_MANAGEMENT):
      return MenuLabel.SQL_EDITOR_MANAGEMENT;
    case pathname.includes(RoutePath.LOG_MANAGEMENT):
      return MenuLabel.LOG_MANAGEMENT;
    case pathname.includes(RoutePath.BOOK_TIME_MANAGEMENT):
      return MenuLabel.BOOK_TIME_MANAGEMENT;
    case pathname.includes(RoutePath.FEED_MANAGEMENT):
      return MenuLabel.FEED_MANAGEMENT;

    default:
      return "";
  }
};
